import cx from 'classnames'
import * as React from 'react'
import Slider from 'react-slick/lib'

import { angleLeft, angleRight } from '../../icons'
import type { FlowCardViewModel } from '../../view-models/FlowCardViewModel'
import { trackEvent } from '../../utils/gtag'
import Button from '../_legacy/Button'
import FlowCard from '../FlowCard/FlowCard'
import Icon from '../Icon/Icon'
import Paragraph from '../Paragraph/Paragraph'
import styles from './flowCarousel-style.css'

type Props = {
  items: Array<FlowCardViewModel>
  onClick?: (...args: Array<any>) => any
}
type State = {
  activeSlide: number
}

class FlowSlider extends React.Component<Props, State> {
  state = {
    activeSlide: 0,
  }
  slider: React.RefObject<any> = React.createRef()

  handleNext = () => {
    // think of something better here
    this.slider.current && this.slider.current.slickNext()

    //fire 'end' metaEvent
    if (this.state.activeSlide + 2 === this.props.items.length) {
      trackEvent({
        event: 'flow',
        eventData: 'end',
      })
    }
  }

  handlePrevious = () => {
    this.slider.current && this.slider.current.slickPrev()
  }

  render() {
    const { items, onClick } = this.props
    if (!items) return null
    const settings = {
      dots: false,
      arrows: false,
      infinite: false,
      speed: 300,
      // adaptiveHeight: false, // set to true, and it looks much better, but client wants set height
      fade: true,
      afterChange: (i) =>
        this.setState({
          activeSlide: i,
        }),
    }

    return (
      <Slider ref={this.slider} {...settings}>
        {items.map((item, i) => (
          <div key={`flow-${i}`}>
            <div className={styles.cardInner}>
              <FlowCard {...item} className={`slide_${i}`} />
              <div className={styles.controlPanel}>
                <Paragraph className={cx(styles.flowCardTextColor, styles.counter)}>
                  {`${i + 1}/${items.length}`}
                </Paragraph>
                <div className={styles.flex}>
                  <div className={styles.navBtn}>
                    <Button
                      onClick={i === 0 ? onClick : this.handlePrevious}
                      darkBg
                      className={styles.flowPrev}
                    >
                      <Icon iconSrc={angleRight} width="8px" height="16px" />
                    </Button>
                  </div>

                  {i !== items.length - 1 && (
                    <div className={styles.navBtn}>
                      <Button onClick={this.handleNext} darkBg className={styles.flowNext}>
                        <Icon iconSrc={angleLeft} width="8px" height="16px" />
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    )
  }
}

export default FlowSlider
